import React from 'react';
// import material ui
import {makeStyles} from '@material-ui/core/styles';
// import i18n
import {useTranslation} from 'react-i18next';
// import router
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: 32,
    paddingBottom: 32,
    [theme.breakpoints.down(476)]: {
      paddingTop: 16,
      paddingBottom: 16,
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 15,
    width: '100%',
    fontSize: 13,
    fontWeight: 600,
    padding: '15px 0',
    '& span': {
      flex: '1 1 auto',
    },
    '&:not(:last-child)': {
      borderBottom: '1px solid #E9EAF3',
    },
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    color: '#555F7E',
  },
}));

const DashboardStoreKeeper = props => {
  const {data, notAllManagerDataCondition} = props;

  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <div className={`dashboard-card ${classes.wrapper}`}>
      {notAllManagerDataCondition === true ? (
        <div className="dashboard-card-empty">
          {t('common:fill_user_details_label')}
        </div>
      ) : !data ? (
        <div className="dashboard-card-empty">
          {t('common:unknown_error_label')}
        </div>
      ) : null}
      <h2 className="dashboard-title">{t('common:store_instruction')}</h2>
      <div className={classes.item}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{maxWidth: '17px', maxHeight: '15px'}}
          fill="#000000"
          version="1.1"
          id="Capa_1"
          width="800px"
          height="800px"
          viewBox="0 0 325.051 325.051">
          <script xmlns="" id="eppiocemhmnlbhjplcgkofciiegomcon" />
          <script xmlns="" />
          <script xmlns="" />
          <g>
            <g>
              <path d="M162.523,86.532c-41.904,0-76,34.089-76,75.994c0,41.901,34.096,75.996,76,75.996s76-34.095,76-75.996    C238.523,120.621,204.427,86.532,162.523,86.532z M162.523,226.225c-35.128,0-63.702-28.571-63.702-63.699    c0-35.122,28.574-63.696,63.702-63.696c35.131,0,63.702,28.574,63.702,63.696C226.225,197.653,197.654,226.225,162.523,226.225z" />
              <path d="M302.503,130.583h-11.505c-5.975-24.202-18.537-45.916-36.587-63.3l5.765-9.977c6.329-10.965-0.865-26.571-16.382-35.531    c-6.484-3.738-13.654-5.803-20.206-5.803c-8.473,0-15.3,3.419-18.74,9.37l-5.759,9.974c-23.749-6.83-49.345-6.83-73.121,0    l-5.755-9.974c-3.444-5.957-10.269-9.37-18.744-9.37c-6.548,0-13.724,2.065-20.203,5.803C65.752,30.729,58.55,46.33,64.879,57.3    l5.768,9.977c-18.065,17.39-30.615,39.104-36.593,63.312H22.554C9.908,130.589,0,144.613,0,162.525s9.908,31.945,22.554,31.945    h11.499c5.978,24.199,18.534,45.913,36.593,63.303l-5.768,9.98c-6.329,10.964,0.874,26.564,16.387,35.523    c6.479,3.735,13.655,5.801,20.203,5.801c8.476,0,15.3-3.423,18.744-9.367l5.755-9.968c23.77,6.827,49.372,6.827,73.115-0.013    l5.765,9.98c3.44,5.957,10.268,9.367,18.74,9.367c6.552,0,13.722-2.065,20.206-5.801c15.517-8.959,22.711-24.56,16.382-35.523    l-5.765-9.98c18.062-17.39,30.612-39.104,36.587-63.303h11.493c12.64,0,22.554-14.027,22.56-31.945    c0.007-8.043-2.041-15.69-5.764-21.539C315.089,134.375,308.965,130.583,302.503,130.583z M302.492,182.173h-16.399    c-2.918,0-5.428,2.054-6.017,4.906c-5.23,25.196-18.212,47.653-37.536,64.941c-2.168,1.94-2.684,5.141-1.225,7.656l8.215,14.226    c2.432,4.203-2.145,13.103-11.884,18.723c-8.779,5.092-19.636,5.272-22.146,0.938l-8.215-14.22    c-1.123-1.946-3.177-3.075-5.32-3.075c-0.643,0-1.297,0.108-1.928,0.307c-24.205,7.98-50.771,7.992-75.018,0.006    c-2.759-0.889-5.786,0.24-7.248,2.769l-8.202,14.214c-2.504,4.335-13.352,4.154-22.149-0.932    c-9.74-5.62-14.309-14.52-11.886-18.723l8.214-14.226c1.45-2.521,0.94-5.716-1.222-7.649    c-19.332-17.294-32.314-39.752-37.542-64.948c-0.594-2.853-3.11-4.899-6.02-4.899H22.548c-4.837,0-10.256-8.401-10.256-19.648    c0-11.241,5.419-19.639,10.256-19.639h16.405c2.916,0,5.432-2.047,6.02-4.902c5.233-25.208,18.215-47.667,37.539-64.948    c2.17-1.939,2.681-5.137,1.225-7.656l-8.214-14.222c-2.429-4.207,2.147-13.105,11.886-18.726    c8.797-5.083,19.639-5.269,22.149-0.934l8.203,14.216c1.456,2.528,4.488,3.672,7.248,2.774c24.232-7.974,50.801-7.974,75.03,0    c2.769,0.892,5.783-0.24,7.248-2.768L215.5,31.51c2.504-4.32,13.354-4.144,22.146,0.942c9.739,5.618,14.304,14.523,11.878,18.729    l-8.215,14.222c-1.453,2.522-0.938,5.716,1.225,7.656c19.323,17.282,32.306,39.74,37.53,64.945c0.601,2.852,3.11,4.9,6.022,4.9    h16.411c2.174,0,4.504,1.714,6.413,4.71c2.438,3.843,3.837,9.284,3.837,14.94C312.748,173.772,307.326,182.173,302.492,182.173z" />
            </g>
          </g>
        </svg>
        <span>Налаштування стандартної адреси</span>
        <Link className={classes.link} to={'/dashboard/storekeeper-settings'}>
          Налаштувати{' '}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668"
              stroke="#555F7E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
      <div className={classes.item}>
        <svg
          style={{minWidth: '17px'}}
          width="17"
          height="15"
          viewBox="0 0 17 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.8705 2.01617L16.1564 10.697C16.9161 11.9438 16.543 13.5842 15.3227 14.3604C14.9131 14.6219 14.4357 14.7612 13.9477 14.7617H3.37501C1.93854 14.7617 0.773438 13.5717 0.773438 12.1025C0.773438 11.6055 0.909905 11.1194 1.16628 10.697L6.45303 2.01617C7.21188 0.769386 8.81637 0.387495 10.0367 1.16372C10.3743 1.37839 10.6599 1.67006 10.8705 2.01617ZM9.11928 2.66873C9.02271 2.60749 8.91455 2.56618 8.80133 2.54731C8.68812 2.52843 8.5722 2.53238 8.46057 2.55891C8.34895 2.58544 8.24394 2.63401 8.15188 2.70168C8.05983 2.76935 7.98264 2.85472 7.92499 2.95263L2.63902 11.635C2.55316 11.7765 2.5079 11.9384 2.50808 12.1033C2.50808 12.5933 2.89618 12.9899 3.37579 12.9899H13.9469C14.1094 12.9899 14.268 12.9433 14.4052 12.8561C14.6022 12.7271 14.7411 12.5281 14.7929 12.3007C14.8448 12.0732 14.8057 11.8348 14.6837 11.635L9.39774 2.95263C9.32841 2.83831 9.23342 2.74119 9.12007 2.66873H9.11928ZM8.66176 11.6506C8.45255 11.6506 8.2519 11.5686 8.10397 11.4228C7.95603 11.2769 7.87292 11.0791 7.87292 10.8728C7.87292 10.6665 7.95603 10.4687 8.10397 10.3228C8.2519 10.177 8.45255 10.095 8.66176 10.095C8.87097 10.095 9.07161 10.177 9.21954 10.3228C9.36748 10.4687 9.45059 10.6665 9.45059 10.8728C9.45059 11.0791 9.36748 11.2769 9.21954 11.4228C9.07161 11.5686 8.87097 11.6506 8.66176 11.6506ZM8.66176 4.65053C8.87097 4.65053 9.07161 4.73247 9.21954 4.87834C9.36748 5.0242 9.45059 5.22203 9.45059 5.42831V8.53945C9.45059 8.74573 9.36748 8.94356 9.21954 9.08942C9.07161 9.23529 8.87097 9.31723 8.66176 9.31723C8.45255 9.31723 8.2519 9.23529 8.10397 9.08942C7.95603 8.94356 7.87292 8.74573 7.87292 8.53945V5.42831C7.87292 5.22203 7.95603 5.0242 8.10397 4.87834C8.2519 4.73247 8.45255 4.65053 8.66176 4.65053Z"
            fill="#FFA000"
          />
        </svg>
        <span style={{color: '#FFBE00'}}>
          {data?.In_processing} {t('common:orders_in_processing_label')}
        </span>
        <Link className={classes.link} to={'/dashboard/storekeeper'}>
          {t('common:perform_label')}{' '}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668"
              stroke="#555F7E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
      <div className={classes.item}>
        <svg
          style={{minWidth: '16px'}}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.49306 0.0148544L7.10706 0.0548544C5.23406 0.241854 3.34706 1.20785 2.07106 2.63385C0.660062 4.21085 -0.0569381 6.16785 0.00906191 8.25285C0.124062 11.8539 2.59906 14.9029 6.11006 15.7709C7.14378 16.0205 8.21678 16.0624 9.26682 15.8942C10.3169 15.7259 11.3231 15.3509 12.2271 14.7909C14.0048 13.6832 15.2773 11.9224 15.7711 9.88685C15.9431 9.18585 15.9831 8.82885 15.9831 7.99985C15.9831 7.17085 15.9431 6.81385 15.7711 6.11285C14.9791 2.87785 12.3151 0.497854 9.00006 0.0638544C8.71606 0.0268544 7.68306 -0.00614561 7.49306 0.0148544ZM8.85306 1.56285C9.97634 1.71072 11.0417 2.14879 11.9441 2.83385C12.2731 3.07985 12.9201 3.72685 13.1661 4.05585C13.7271 4.80685 14.1421 5.68985 14.3301 6.53485C14.5441 7.4998 14.5441 8.49991 14.3301 9.46485C13.9161 11.3259 12.6051 12.9779 10.8671 13.8279C10.2405 14.1345 9.57021 14.3423 8.88006 14.4439C8.45606 14.5089 7.54406 14.5089 7.12006 14.4439C5.17206 14.1479 3.52806 13.0849 2.49306 11.4509C2.23848 11.0288 2.02612 10.5826 1.85906 10.1189C1.62087 9.43817 1.5041 8.72094 1.51406 7.99985C1.51406 6.96085 1.71506 6.07485 2.16006 5.15985C2.50006 4.46185 2.84606 3.97985 3.41306 3.41285C3.91457 2.89268 4.50654 2.46809 5.16006 2.15985C6.30509 1.60052 7.59012 1.39278 8.85306 1.56285ZM7.70606 4.28985C7.48206 4.36285 7.35506 4.49085 7.29306 4.70485C7.25706 4.82685 7.25306 5.10585 7.25906 6.81585C7.26706 8.78585 7.26706 8.78685 7.32506 8.89585C7.40126 9.03548 7.52355 9.14434 7.67106 9.20385C7.80306 9.24985 8.19706 9.24985 8.32906 9.20385C8.47657 9.14434 8.59886 9.03548 8.67506 8.89585C8.73306 8.78685 8.73306 8.78585 8.74106 6.81585C8.74906 4.66385 8.74906 4.66185 8.59606 4.48085C8.47206 4.33285 8.33906 4.28385 8.04006 4.27585C7.92854 4.26957 7.81667 4.27426 7.70606 4.28985ZM7.78606 10.5299C7.58599 10.6014 7.41958 10.7447 7.31906 10.9319C7.24687 11.1112 7.23805 11.3098 7.29406 11.4949C7.34813 11.6397 7.4442 11.7652 7.56997 11.8551C7.69574 11.9451 7.84549 11.9955 8.00006 11.9999C8.30306 11.9999 8.61206 11.7799 8.70606 11.4949C8.76207 11.3098 8.75325 11.1112 8.68106 10.9319C8.59828 10.7858 8.47819 10.6643 8.33306 10.5799C8.21706 10.5199 7.90406 10.4909 7.78606 10.5299Z"
            fill="#279F51"
          />
        </svg>
        <span style={{color: '#279F51'}}>
          {data?.Accepted} {t('common:orders_accepted_label')}
        </span>
        <Link className={classes.link} to={'/dashboard/storekeeper'}>
          {t('common:perform_label')}{' '}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668"
              stroke="#555F7E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
      <div className={classes.item}>
        <svg
          style={{minWidth: '16px'}}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.49306 0.0148544L7.10706 0.0548544C5.23406 0.241854 3.34706 1.20785 2.07106 2.63385C0.660062 4.21085 -0.0569381 6.16785 0.00906191 8.25285C0.124062 11.8539 2.59906 14.9029 6.11006 15.7709C7.14378 16.0205 8.21678 16.0624 9.26682 15.8942C10.3169 15.7259 11.3231 15.3509 12.2271 14.7909C14.0048 13.6832 15.2773 11.9224 15.7711 9.88685C15.9431 9.18585 15.9831 8.82885 15.9831 7.99985C15.9831 7.17085 15.9431 6.81385 15.7711 6.11285C14.9791 2.87785 12.3151 0.497854 9.00006 0.0638544C8.71606 0.0268544 7.68306 -0.00614561 7.49306 0.0148544ZM8.85306 1.56285C9.97634 1.71072 11.0417 2.14879 11.9441 2.83385C12.2731 3.07985 12.9201 3.72685 13.1661 4.05585C13.7271 4.80685 14.1421 5.68985 14.3301 6.53485C14.5441 7.4998 14.5441 8.49991 14.3301 9.46485C13.9161 11.3259 12.6051 12.9779 10.8671 13.8279C10.2405 14.1345 9.57021 14.3423 8.88006 14.4439C8.45606 14.5089 7.54406 14.5089 7.12006 14.4439C5.17206 14.1479 3.52806 13.0849 2.49306 11.4509C2.23848 11.0288 2.02612 10.5826 1.85906 10.1189C1.62087 9.43817 1.5041 8.72094 1.51406 7.99985C1.51406 6.96085 1.71506 6.07485 2.16006 5.15985C2.50006 4.46185 2.84606 3.97985 3.41306 3.41285C3.91457 2.89268 4.50654 2.46809 5.16006 2.15985C6.30509 1.60052 7.59012 1.39278 8.85306 1.56285ZM7.70606 4.28985C7.48206 4.36285 7.35506 4.49085 7.29306 4.70485C7.25706 4.82685 7.25306 5.10585 7.25906 6.81585C7.26706 8.78585 7.26706 8.78685 7.32506 8.89585C7.40126 9.03548 7.52355 9.14434 7.67106 9.20385C7.80306 9.24985 8.19706 9.24985 8.32906 9.20385C8.47657 9.14434 8.59886 9.03548 8.67506 8.89585C8.73306 8.78685 8.73306 8.78585 8.74106 6.81585C8.74906 4.66385 8.74906 4.66185 8.59606 4.48085C8.47206 4.33285 8.33906 4.28385 8.04006 4.27585C7.92854 4.26957 7.81667 4.27426 7.70606 4.28985ZM7.78606 10.5299C7.58599 10.6014 7.41958 10.7447 7.31906 10.9319C7.24687 11.1112 7.23805 11.3098 7.29406 11.4949C7.34813 11.6397 7.4442 11.7652 7.56997 11.8551C7.69574 11.9451 7.84549 11.9955 8.00006 11.9999C8.30306 11.9999 8.61206 11.7799 8.70606 11.4949C8.76207 11.3098 8.75325 11.1112 8.68106 10.9319C8.59828 10.7858 8.47819 10.6643 8.33306 10.5799C8.21706 10.5199 7.90406 10.4909 7.78606 10.5299Z"
            fill="#1F1F1F"
          />
        </svg>
        <span style={{color: '#1F1F1F'}}>
          {t('common:stock_balances_label')}
        </span>
        <Link className={classes.link} to={'/dashboard/goods'}>
          {t('common:get_label')}{' '}
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.3335 6.00016H10.6668M10.6668 6.00016L6.00016 1.3335M10.6668 6.00016L6.00016 10.6668"
              stroke="#555F7E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default DashboardStoreKeeper;
